import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const MembershipEligibility = () => {
  // Membership categories based on provided content
  const membershipCategories = [
    {
      title: 'Full Members',
      description: 'All NLNG, NSML, and RAIS Direct Staff and Secondees based in Bonny Island are full members of The Club.',
      note: 'Suspension of members in this category can only be with the approval of The Company.',
      icon: 'fa-user-check',
    },
    {
      title: 'Junior Members',
      description: 'Children aged 12 to 18 years, whose parents are full members of The Club and have not been suspended.',
      note: 'Their interests should be captured in The Club\'s planning and activities.',
      icon: 'fa-child',
    },
    {
      title: 'Family Members',
      description: 'Children under 12 or above 18 years, whose parents are full members of The Club and have not been suspended.',
      note: 'Their interests should be captured in The Club\'s planning and activities.',
      icon: 'fa-users',
    },
    {
      title: 'Honorary Members',
      description: 'RCEC may, in consultation with The Company, confer renewable one-year memberships on deserving personalities.',
      note: 'Limited to five per year. The basis for such conferment shall be communicated to members at a general meeting.',
      icon: 'fa-medal',
    },
    {
      title: 'Associate Members',
      description: 'Employees of JV Oil/Gas Companies or major NLNG contractors on Bonny Island may apply for renewable one-year memberships.',
      note: 'Applications must be made through management to RCEC with verifiable employment evidence. Requires The Company\'s approval. All prevailing fees apply.',
      icon: 'fa-handshake',
    },
    {
      title: 'Non-Bonny Staff',
      description: 'NLNG staff visiting from other locations may use Club facilities upon presenting a valid ID card but cannot become members.',
      icon: 'fa-passport',
    },
  ];

  // "Others" subcategories
  const otherCategories = [
    { title: 'Dependants', description: 'Dependants above 12 years may use Club facilities with a valid family ID card but cannot become members.' },
    { title: 'Guests', description: 'Guests may use Club facilities when signed in by a host member but cannot become members.' },
    { title: 'SIWES', description: 'SIWES with NLNG may use Club facilities with a valid ID card but cannot become members.' },
    { title: 'Domestic Staff', description: 'Domestic staff may use Club facilities with a valid ID card but cannot become members.' },
  ];

  return (
    <div className="eligibility-page">
      {/* Hero Section */}
      <section className="page-hero eligibility-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="hero-eyebrow">THE CLUB</span>
            <h1 className="hero-title">Club <span className="text-green">Membership</span></h1>
            <p className="hero-subtitle">Admission into RA Club membership – categories, rules, and privileges</p>
          </motion.div>
        </div>
      </section>

      {/* Membership Categories Grid */}
      <section className="eligibility-section">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">MEMBERSHIP CATEGORIES</span>
            <h2 className="section-title">Who Can <span className="text-green">Join</span></h2>
            <p className="section-subtitle">Clear definitions of membership types and their associated conditions</p>
          </div>

          <div className="eligibility-grid">
            {membershipCategories.map((item, index) => (
              <motion.div
                key={index}
                className="eligibility-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="eligibility-icon">
                  <i className={`fas ${item.icon}`}></i>
                </div>
                <h3>{item.title}</h3>
                <p className="eligibility-description">{item.description}</p>
                {item.note && <p className="eligibility-note"><strong>Note:</strong> {item.note}</p>}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* "Others" Section – Special Cases */}
      <section className="membership-types-section">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">SPECIAL CASES</span>
            <h2 className="section-title">Other <span className="text-green">Categories</span></h2>
            <p className="section-subtitle">Limited facility access for non-members with valid identification</p>
          </div>

          <div className="others-grid">
            {otherCategories.map((item, index) => (
              <motion.div
                key={index}
                className="other-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                viewport={{ once: true }}
              >
                <i className="fas fa-id-card"></i>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </motion.div>
            ))}
          </div>

          <div className="eligibility-cta">
            <p>Ready to apply or have questions about membership?</p>
            <Link to="/login" className="btn btn-primary btn-large">Apply Now</Link>
            <Link to="/contact" className="btn btn-outline btn-large">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MembershipEligibility;